import {
    Component,
    Input
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    standalone: true,
    imports: [CommonModule, MatProgressSpinnerModule, TranslateModule],
})
export class LoaderComponent {
    @Input() showLoader: boolean = true;
    ngOnChanges() {
        this.handleBodyScroll();
    }

    private handleBodyScroll() {
        document.body.style.overflowY = this.showLoader ? 'hidden' : 'auto';
    }
}
